import type { TranslationResource } from './de';

export const it: TranslationResource = {
  common: {
    siteName: 'Die Sizilianer',
    siteTagline: 'Specialità siciliane a Dorsten',
    loading: 'Caricamento…',
    error: 'Errore',
    save: 'Salva',
    cancel: 'Annulla',
    submit: 'Invia',
    delete: 'Elimina',
    edit: 'Modifica',
    close: 'Chiudi',
    open: 'Apri',
    back: 'Indietro',
    next: 'Avanti',
    yes: 'Sì',
    no: 'No',
  },

  nav: {
    home: 'Home',
    menu: 'Menù',
    reservation: 'Prenotazione',
    events: 'Eventi',
    gallery: 'Galleria',
    about: 'Chi siamo',
    contact: 'Contatti',
    impressum: 'Impressum',
    privacy: 'Privacy',
    terms: 'Termini',
    newsletter: 'Newsletter',
    laputia: 'La Putia',
  },

  language: {
    label: 'Lingua',
    de: 'Deutsch',
    it: 'Italiano',
    en: 'English',
  },

  menu: {
    eyebrow: 'Buon appetito',
    title: 'Menù',
    lede: 'Cucina siciliana autentica — preparata fresca, servita con amore. Tutti i prezzi in Euro IVA inclusa.',
    searchPlaceholder: 'Cerca piatto…',
    diet: {
      vegetarian: 'Vegetariano',
      vegan: 'Vegano',
      glutenFree: 'Senza glutine',
      lactoseFree: 'Senza lattosio',
      special: 'Oggi',
      seasonal: 'Stagionale',
      seasonalUntil: 'Stagionale fino al {{date}}',
    },
    filterMatches: '{{count}} risultati',
    filterReset: 'Reset filtri',
    empty: {
      title: 'Nessun piatto disponibile',
      description: 'Al momento non ci sono piatti disponibili. Riprova più tardi.',
      filteredTitle: 'Nessun piatto corrispondente',
      filteredDescription: 'Nessun piatto corrisponde ai filtri selezionati. Reimposta i filtri per vedere tutto il menù.',
    },
    allergens: 'Allergeni',
    price: 'Prezzo',
    tableContext: {
      tavolo: 'Tavolo',
      table: 'Tavolo',
      callService: 'Chiama il personale',
      hint: 'Sfoglia il menù. Per ordinare rivolgiti al personale.',
    },
  },

  home: {
    pageTitle: 'Ristorante siciliano',
    pageDescription: 'Autentica cucina siciliana nel cuore di Dorsten.',
    hero: {
      imageAlt: 'Scena siciliana con Trinacria, Etna, tempio antico e fico d\'India',
      kicker: 'Cucina siciliana autentica',
      title: 'DIE SIZILIANER',
      ledeLine1: 'Ricette autentiche. Ingredienti di prima qualità.',
      ledeLine2: 'Un pezzo di Sicilia. Nel cuore di Dorsten.',
      reserveCta: 'Prenota un tavolo',
    },
    trustLine: '4,6 su 5 su Google · oltre 1.700 recensioni →',
    kueche: {
      eyebrow: 'La nostra cucina',
      title: 'Una festa per i sensi',
      sub: 'Sapori siciliani, preparati secondo tradizione. Serviti con amore.',
      cards: {
        antipasti: 'Antipasti',
        antipastiSub: 'L\'inizio perfetto',
        pasta: 'Pasta',
        pastaSub: 'Tradizione & passione',
        pesce: 'Pesce',
        pesceSub: 'Fresco dal mare',
        dolci: 'Dolci',
        dolciSub: 'Dolce tentazione',
      },
    },
    events: {
      eyebrow: 'Eventi',
      title: 'Gusto. Musica. Momenti.',
      text: 'Vivi serate speciali con cucina siciliana, musica dal vivo e vera ospitalità.',
      cta: 'Tutti gli eventi',
      loading: 'Caricamento…',
      emptyTitle: 'Al momento nessun appuntamento',
      emptyText: 'Stiamo pianificando i prossimi eventi. Torna presto a trovarci o prenotaci per il tuo evento.',
      emptyCta: 'Prenota l\'Ape',
      fallbackTitle: 'Evento Ape',
      more: 'Scopri di più',
    },
    laPutiaTeaser: {
      badge: 'Novità: il nostro negozio',
      title: 'La Putia',
      imageAlt: 'La Putia',
      taglineFallback: 'Bottega siciliana a Dorsten',
      text: 'Specialità siciliane da asporto — formaggi, salumi, olio d\'oliva di Agrigento, arancini e panini siciliani. Nel centro di Dorsten.',
      ctaOpen: 'Scopri La Putia',
      ctaClosed: 'Prossimamente — scopri di più',
    },
  },

  galerie: {
    title: 'Galleria',
    scriptLine: 'Impressioni',
    lede: 'La Sicilia in immagini — illustrazioni dell\'isola, dei suoi colori e della sua cucina che ci ispirano.',
    instagram: 'Per altre impressioni seguici su Instagram',
    captions: {
      sizilien: 'Sicilia',
      antipasti: 'Antipasti',
      pasta: 'Pasta',
      trinacria: 'Trinacria',
      pesce: 'Pesce',
      cannoli: 'Cannoli',
      ficoDIndia: "Fico d'India",
      olivo: 'Olivo',
      piazza: 'Piazza',
      limoni: 'Limoni',
      pomodoro: 'Pomodoro',
      cucina: 'Cucina',
    },
  },

  laPutia: {
    pageTitle: 'La Putia',
    pageDescription: 'La Putia — bottega siciliana nel centro di Dorsten. Gastronomia, street food e specialità da asporto. Da Die Sizilianer.',
    storeDescriptionFallback: 'Bottega siciliana nel centro di Dorsten',
  },

  ape: {
    shared: {
      toHome: 'Torna alla home',
      toApeBookings: 'Alle prenotazioni Ape',
      loadingBooking: 'Caricamento prenotazione…',
      bookingNotFound: 'Prenotazione non trovata',
      bookingLoadError: 'Impossibile caricare la prenotazione.',
      noTokenTitle: 'Nessun token',
      unknownError: 'Errore sconosciuto',
      errorPrefix: 'Errore: {{message}}',
      flatPrice: 'Prezzo forfettario',
      statusConfirmed: 'Confermata',
      statusCancelled: 'Annullata',
      timeAt: 'ore {{time}}',
    },
    requestReceived: {
      pageTitle: 'Richiesta ricevuta',
      scriptLine: 'Grazie mille',
      title: 'Richiesta ricevuta',
      body: 'Abbiamo ricevuto la tua richiesta e ti chiameremo entro 48 ore per discutere i dettagli e preparare un\'offerta vincolante.',
      whatNow: 'Cosa succede ora?',
      step1: '<strong>1.</strong> Verifichiamo la disponibilità e ti chiamiamo',
      step2: '<strong>2.</strong> Definiamo insieme menù, numero di persone e programma',
      step3: '<strong>3.</strong> Ricevi un\'offerta scritta via e-mail',
      step4: '<strong>4.</strong> Accetti con un clic — fatto',
      callNow: 'Chiama ora',
    },
    bookingConfirmed: {
      pageTitle: 'Prenotazione confermata',
      noTokenText: 'Questa pagina si apre solo tramite il link nella e-mail di conferma.',
      scriptCancelled: 'Peccato',
      scriptConfirmed: 'Siamo felici',
      titleCancelled: 'Prenotazione annullata',
      titleConfirmed: 'Prenotazione confermata',
      introCancelled: 'Questa prenotazione è stata annullata. Speriamo in un\'altra occasione.',
      introConfirmed: 'La tua prenotazione dell\'Ape è vincolante. Non vediamo l\'ora dell\'evento!',
      eventFallback: 'Evento',
      statusBinding: 'Vincolante',
      cancelCta: 'Annulla',
      mailNote: 'Riceverai anche una e-mail di conferma con tutti i dettagli.',
    },
    cancel: {
      pageTitle: 'Annulla prenotazione',
      noTokenText: 'Questa pagina si apre solo tramite il link di annullamento nella e-mail di conferma.',
      toastAlready: 'La prenotazione era già stata annullata.',
      toastCancelled: 'La prenotazione è stata annullata.',
      scriptLine: 'Alla prossima',
      cancelledTitle: 'Prenotazione annullata',
      cancelledBody: 'La tua prenotazione del {{date}} è stata annullata. Speriamo di rivederti presto in un\'altra occasione.',
      newRequest: 'Nuova richiesta',
      confirmTitle: 'Annullare la prenotazione?',
      confirmText: 'La prenotazione verrà annullata e la data tornerà disponibile. Questa azione è irreversibile.',
      bookingFallback: 'Prenotazione',
      name: 'Nome',
      date: 'Data',
      time: 'Ora',
      location: 'Luogo',
      reasonLabel: 'Motivo (opzionale)',
      reasonHint: 'Ci aiuta a migliorare il nostro servizio',
      reasonPlaceholder: 'es. la data è cambiata',
      keepButton: 'No, la tengo',
      cancelButton: 'Annulla prenotazione',
    },
    quote: {
      pageTitle: 'La tua offerta',
      noTokenTitle: 'Nessun token presente',
      noTokenText: 'Questa pagina si apre solo tramite il link nella e-mail dell\'offerta.',
      toastAlready: 'La prenotazione era già confermata.',
      toastAccepted: 'Prenotazione confermata in modo vincolante!',
      loading: 'Caricamento offerta…',
      notFound: 'Offerta non trovata',
      loadError: 'Impossibile caricare l\'offerta.',
      scriptLine: 'La tua offerta',
      cancelledTitle: 'La prenotazione è già stata annullata',
      cancelledText: 'Se vuoi riattivare l\'evento, chiamaci.',
      confirmedTitle: 'Prenotazione già confermata',
      confirmedText: 'Non vediamo l\'ora di vederti!',
      keyFacts: 'Dati principali',
      statusPleaseConfirm: 'Da confermare',
      guestsApprox: 'ca. {{guests}} persone',
      notes: 'Note',
      acceptHint: 'Se l\'offerta ti va bene, accettala qui in modo vincolante. Ti inviamo subito una e-mail di conferma.',
      acceptCta: 'Accetta l\'offerta in modo vincolante',
      phoneHint: 'Preferisci parlarne al telefono?',
    },
  },

  reservation: {
    title: 'Prenota un tavolo',
    eyebrow: 'Prenotazione',
    scriptLine: 'Riserva il tuo tavolo',
    intro: 'Scegli data, ora e numero di persone — confermiamo subito le prenotazioni fino a 6 persone.',
    // Reservierungsstopp (0089)
    stop: {
      title: 'Al momento nessuna prenotazione online',
      body: 'A causa dell’elevata richiesta al momento non possiamo purtroppo accettare nuove prenotazioni. Vi preghiamo di riprovare più tardi.',
      dayBody: 'Per questo giorno purtroppo non accettiamo prenotazioni online. Vi preghiamo di scegliere un altro giorno o di chiamarci.',
    },
    step1: {
      guestsLabel: 'Quante persone?',
      guestsHint: 'Fino a 6 persone confermiamo subito, per 7–12 persone su richiesta. Per più di 12 persone chiamaci direttamente:',
      dateLabel: 'Quale giorno?',
      timeLabel: 'A che ora?',
      continue: 'Avanti',
    },
    step2: {
      title: 'Dati di contatto',
      name: 'Nome',
      email: 'E-mail',
      phone: 'Telefono',
      notes: 'Note (opzionale)',
      notesHint: 'Allergie, preferenze al tavolo, occasione',
      birthday: 'Festeggiamo un compleanno',
      birthdayDate: 'Data di nascita',
      birthdayHint: 'Per conoscere il festeggiato',
      areaPreference: 'Preferenza zona (opzionale)',
      areaInside: 'Interno',
      areaTerrace: 'Terrazza',
      areaNoPreference: 'Indifferente',
      back: 'Indietro',
      continue: 'Avanti al riepilogo',
    },
    step3: {
      title: 'Riepilogo',
      lede: 'Controlla i tuoi dati.',
      submit: 'Prenota in modo vincolante',
      submitting: 'Invio…',
    },
    slotPicker: {
      loading: 'Caricamento disponibilità…',
      emptyTitle: 'Nessun orario libero',
      emptyDefault: 'Nessuno slot disponibile per questo giorno.',
      groupLabel: 'Seleziona un orario',
      seatsFree: 'ancora {{count}}',
    },
    guestsPicker: {
      groupLabel: 'Numero di ospiti',
      decrease: 'Una persona in meno',
      increase: 'Una persona in più',
      person: 'Persona',
      persons: 'Persone',
    },
    datePicker: {
      groupLabel: 'Seleziona una data',
      today: 'Oggi',
    },
    availability: {
      title: 'Disponibilità live',
      today: 'Oggi',
      full: 'Completo',
      free: 'liberi',
    },
    waitlistForm: {
      errorName: 'Inserisci nome e cognome',
      errorEmail: 'E-mail valida richiesta',
      errorPhone: 'Telefono richiesto',
      joinFailed: 'Iscrizione non riuscita',
      successTitle: 'Sei in lista d\'attesa!',
      successPosition: 'Sei in <strong>posizione {{position}}</strong> per {{date}} alle {{time}}.',
      successNote: 'Ti avviseremo via e-mail non appena si libera un posto.',
      title: 'Mettiti in lista d\'attesa',
      summaryOne: '{{date}} · ore {{time}} · {{guests}} persona',
      summaryMany: '{{date}} · ore {{time}} · {{guests}} persone',
      note: 'Ti scriviamo subito non appena si libera un tavolo (link valido 24 h).',
      namePlaceholder: 'Nome e cognome',
      emailPlaceholder: 'E-mail',
      phonePlaceholder: 'Telefono',
      notesPlaceholder: 'Note (opzionale)',
      submit: 'In lista d\'attesa',
      cancel: 'Annulla',
    },
    calendar: {
      addToCalendar: 'Aggiungi al calendario',
      google: 'Google Calendar',
      googleHint: 'Si apre nel browser',
      apple: 'Apple / Outlook (.ics)',
      appleHint: 'Scarica e fai doppio clic',
      outlook: 'Outlook.com',
      outlookHint: 'Microsoft Web',
      eventTitle: 'Prenotazione — Die Sizilianer',
      manageHint: 'Vedi, modifica o annulla la prenotazione (link valido fino al giorno della prenotazione):',
      eventDescriptionOne: '{{guests}} persona · Prenotazione a nome {{name}}.',
      eventDescriptionMany: '{{guests}} persone · Prenotazione a nome {{name}}.',
      addressLine: 'Die Sizilianer · Im Werth 25 · 46282 Dorsten · Tel. 02362 23279',
    },
    shared: {
      loading: 'Caricamento prenotazione…',
      notFound: 'Prenotazione non trovata',
      cardTitle: 'Prenotazione',
      name: 'Nome',
      date: 'Data',
      time: 'Ora',
      guests: 'Persone',
      area: 'Zona',
      notes: 'Note',
      email: 'E-mail',
      timeAt: 'ore {{time}}',
      areaInside: 'Interno',
      areaTerrace: 'Terrazza',
      addressLine: 'Im Werth 25, 46282 Dorsten',
      route: 'Indicazioni →',
      questionsPhone: 'Domande? Tel.',
      newReservation: 'Prenota di nuovo',
      toHome: 'Torna alla home',
      contactUs: 'Contattaci',
      noTokenTitle: 'Nessun token di prenotazione',
      unknownError: 'Errore sconosciuto',
      networkError: 'Errore di rete',
      status: {
        cancelled: 'Annullata',
        pending: 'In verifica',
        confirmed: 'Confermata',
        completed: 'Conclusa',
        noShow: 'Non presentato',
      },
    },
    manage: {
      pageTitle: 'Gestisci prenotazione',
      pageDescription: 'Vedi, modifica o annulla la tua prenotazione da Die Sizilianer a Dorsten',
      scriptLine: 'Benvenuti',
      title: 'La tua prenotazione',
      introOpen: 'Qui puoi vedere, modificare o annullare la tua prenotazione fino al giorno della prenotazione.',
      introInactive: 'Questa prenotazione non è più attiva.',
      editButton: 'Modifica prenotazione',
      cancelButton: 'Annulla prenotazione',
      modifyLockedCancel: 'Le modifiche sono possibili fino a 2 ore prima della prenotazione. Per modifiche dell\'ultimo minuto chiamaci.',
      modifyLockedNoCancel: 'Le modifiche sono possibili fino a 2 ore prima della prenotazione. Per tutto il resto chiamaci.',
      edit: {
        scriptLine: 'Andiamo',
        title: 'Modifica prenotazione',
        previouslyOne: 'Finora: {{date}}, ore {{time}}, {{guests}} persona',
        previouslyMany: 'Finora: {{date}}, ore {{time}}, {{guests}} persone',
        guestsLabel: 'Numero di persone',
        dateLabel: 'Data',
        timeLabel: 'Ora',
        notesLabel: 'Note (opzionale)',
        areaLabel: 'Zona',
        hintLargeGroup: 'Per più di 6 persone verifichiamo di nuovo la modifica manualmente.',
        hintCallUs: 'Per più di 12 persone chiamaci:',
        notesPlaceholder: 'es. allergie, seggiolone, occasione …',
        areaNoPreference: 'Nessuna preferenza',
        back: 'Indietro',
        save: 'Salva modifica',
        saving: 'Salvataggio…',
        closedDay: '{{weekday}} è il nostro giorno di riposo.',
        pastDate: 'Scegli una data futura.',
        closedSpecialDay: 'Questo giorno siamo chiusi.',
        noSlots: 'Nessuno slot libero per questo giorno.',
        toastNoChange: 'Nessuna modifica — tutto resta com\'era.',
        toastPending: 'Modifica salvata! Poiché il tuo gruppo ora supera le 6 persone, verifichiamo di nuovo la prenotazione e ti ricontattiamo.',
        toastSaved: 'Modifica salvata! Riceverai una conferma via e-mail.',
      },
      noTokenText: 'Questa pagina si apre solo tramite il link di gestione nella tua e-mail di prenotazione.',
      expiredTitle: 'Questo link è scaduto',
      expiredText: 'Il link di gestione è valido fino alla fine del giorno della prenotazione. Non vediamo l\'ora di riaverti presto da noi!',
    },
    confirmed: {
      pageTitle: 'Prenotazione',
      pageDescription: 'La tua prenotazione da Die Sizilianer a Dorsten',
      scriptLine: 'Grazie',
      titleCancelled: 'Prenotazione annullata',
      titlePending: 'Richiesta ricevuta',
      titleConfirmed: 'Prenotazione confermata',
      introCancelled: 'Questa prenotazione è stata annullata.',
      introPending: 'Stiamo verificando la tua richiesta e la confermiamo entro 24 ore.',
      introConfirmed: 'Non vediamo l\'ora della tua visita!',
      manageHint: 'Tramite il link di gestione nella tua e-mail di conferma puoi modificare o annullare la prenotazione in ogni momento, <strong>fino al giorno della prenotazione</strong>.',
      manageButton: 'Gestisci prenotazione',
      cancelButton: 'Annulla prenotazione',
      noTokenText: 'Questa pagina si apre solo tramite il link nella e-mail di conferma.',
    },
    cancelPage: {
      pageTitle: 'Annulla prenotazione',
      pageDescription: 'Annullamento della tua prenotazione da Die Sizilianer a Dorsten',
      toastAlreadyCancelled: 'La prenotazione era già stata annullata.',
      toastCancelled: 'La prenotazione è stata annullata.',
      errorPrefix: 'Errore: {{message}}',
      noLinkTitle: 'Nessun link di annullamento',
      noLinkText: 'Questa pagina si apre solo tramite il link di annullamento nella e-mail di conferma.',
      loadError: 'Impossibile caricare questa prenotazione.',
      scriptLine: 'Alla prossima',
      cancelledTitle: 'Prenotazione annullata',
      cancelledBody: 'La tua prenotazione di <strong>{{date}}</strong> alle <strong>{{time}}</strong> è stata annullata. Speriamo di riaverti presto da noi.',
      confirmTitle: 'Annullare la prenotazione?',
      confirmText: 'La prenotazione verrà annullata e il tavolo tornerà disponibile. Questa azione è irreversibile.',
      reasonLabel: 'Motivo (opzionale)',
      reasonHint: 'Ci aiuta a migliorare il nostro servizio',
      reasonPlaceholder: 'es. i piani sono cambiati',
      keepButton: 'No, la tengo',
      cancelButton: 'Annulla prenotazione',
    },
    waitlistClaim: {
      pageTitle: 'Lista d\'attesa · Prenota il posto',
      pageDescription: 'Assicurati il tuo posto dalla lista d\'attesa.',
      noToken: 'Nessun token presente.',
      genericError: 'Errore',
      loading: 'Caricamento…',
      expiredTitle: 'Link scaduto',
      expiredText: 'Il link di prenotazione era valido solo 24 ore. Nel frattempo il posto è stato offerto alla persona successiva in lista d\'attesa.',
      expiredCta: 'Prenota un nuovo tavolo',
      claimedTitle: 'Già prenotato',
      claimedText: 'Hai già trasformato questo posto in una prenotazione confermata. La conferma è nella tua casella di posta.',
      successScript: 'Perfetto!',
      successTitle: 'Prenotazione confermata',
      successText: 'Ti aspettiamo. La conferma è nella tua casella di posta.',
      viewMenu: 'Guarda il menù',
      errorTitle: 'Qualcosa è andato storto',
      readyScript: 'Buon ritorno!',
      readyTitle: 'Un posto si è liberato',
      readyText: 'Un tavolo si è liberato — ora puoi rendere la prenotazione vincolante con un clic.',
      guestsLine: '{{guests}} persone',
      validity: 'Valido 24 h',
      claiming: 'Prenotazione…',
      claimCta: 'Prenota subito il posto',
    },
  },

  footer: {
    address: 'Indirizzo',
    phone: 'Prenotazione',
    hours: 'Orari di apertura',
    follow: 'Seguici',
    newsletter: {
      title: 'Newsletter',
      lede: 'Specialità, piatti di stagione e storie — <strong>1× al mese</strong>.',
    },
  },

  events: {
    title: 'Eventi & Prenotazione Ape',
    eyebrow: 'Eventi',
    scriptLine: 'La nostra Ape',
    lede: 'Portiamo il nostro forno a legna al tuo evento — matrimonio, festa cittadina, festa aziendale. Pizza appena sfornata sul posto.',
    upcoming: 'Siamo qui',
    upcomingEmpty: 'Attualmente nessun evento pubblico — scrivici per una prenotazione privata.',
    publicEmptyTitle: 'Al momento nessuna apparizione pubblica in programma',
    publicEmptyDescription: 'Pianifichiamo sempre nuovi eventi — torna presto o seguici su Instagram.',
    requestCta: 'Invia richiesta',
    checkAvailability: 'Verifica disponibilità',
    detailsLink: 'Vedi dettagli',
    detailBack: 'Tutti gli eventi',
    detailFallbackTitle: 'Evento pubblico',
    calculator: {
      button: 'Calcola stima',
      calculating: 'Calcolo…',
      title: 'Stima immediata non vincolante',
      persons: 'persone',
      travelIncluded: 'Trasferta: inclusa',
      travelOneWay: 'Trasferta',
      travelRoundTrip: 'Andata e ritorno',
      disclaimer:
        'Stima non vincolante — l\'offerta vincolante arriva via e-mail dopo un colloquio personale.',
      osm: 'Distanza: © OpenStreetMap contributors',
      disabled:
        'La stima immediata al momento non è disponibile — invia comunque la richiesta, ti contatteremo con un\'offerta.',
      belowMin:
        'Per gruppi più piccoli prepariamo volentieri un\'offerta individuale — invia comunque la richiesta.',
      beyondMax:
        'Il luogo si trova fuori dalla nostra zona standard — verifichiamo la tua richiesta manualmente e ti contattiamo.',
      geocodeFailed:
        'Non siamo riusciti a individuare il luogo — verifichiamo la tua richiesta manualmente e ti contattiamo.',
      imprecise:
        'Per questo indirizzo non riusciamo a calcolare la distanza con sufficiente precisione — di solito basta aggiungere via e numero civico. Altrimenti invia la richiesta: calcoleremo a mano.',
    },
    requestForm: {
      title: 'Prenota l\'Ape',
      lede: 'Inviaci i tuoi dati — ti rispondiamo con un\'offerta personalizzata entro 24h.',
      date: 'Data',
      eventType: 'Occasione',
      startTime: 'Ora',
      endTime: 'fino a (opzionale)',
      expectedGuests: 'Ospiti (ca.)',
      salutationOptions: { herr: 'Sig.', frau: 'Sig.ra', keine: 'Nessuna indicazione' },
      titleOptions: { dr: 'Dott.', prof: 'Prof.', prof_dr: 'Prof. Dott.' },
      locationHeading: 'Dove si svolge?',
      locationName: 'Nome del luogo',
      locationNameHint: 'per es. «Sala Schützenhalle Lembeck» — facoltativo',
      locationAddress: 'Indirizzo',
      locationStreet: 'Via e numero civico (opzionale)',
      locationStreetHint: 'Facoltativo — rende più precisa la stima della distanza',
      locationZip: 'CAP',
      locationCity: 'Località',
      phoneHint: 'Per eventuali domande telefoniche sulla tua richiesta',
      isPublic: 'Evento pubblico — può apparire sul nostro sito',
      message: 'Messaggio',
      salutation: 'Titolo di cortesia',
      academicTitle: 'Titolo accademico',
      academicTitleNone: 'nessun titolo',
      firstName: 'Nome',
      lastName: 'Cognome',
      name: 'Nome',
      email: 'E-mail',
      phone: 'Telefono',
      submit: 'Invia richiesta',
      sending: 'Invio…',
    },
    priceMode: {
      pauschal: 'Prezzo forfettario',
      pizzaAb: 'a partire da',
      keinPreis: 'Prezzo su richiesta',
    },
  },

  newsletter: {
    title: 'Newsletter',
    scriptLine: 'Resta in contatto',
    lede: 'Specials stagionali, consigli sui vini siciliani e piccole storie dalla cucina. 1× al mese — niente pubblicità, niente spam.',
    benefits: {
      specials: {
        title: 'Specials stagionali per primi',
        text: 'Sei il primo a scoprire i nuovi piatti.',
      },
      frequency: {
        title: 'Massimo 1× al mese',
        text: 'Nessun bombardamento — promesso.',
      },
    },
    namePlaceholder: 'Il tuo nome',
    emailPlaceholder: 'tua@email.it',
    submit: 'Iscriviti',
    consent: 'Iscrivendoti acconsenti a ricevere email all\'indirizzo indicato. Disiscrizione possibile in ogni momento dal link in ogni messaggio.',
    successPending: 'Quasi fatto — controlla la tua casella di posta.',
    confirmed: {
      title: 'Iscrizione confermata',
      scriptLine: 'Grazie!',
      lede: 'Siamo felici di averti nella nostra lista. Presto ci risentirai.',
      alreadyTitle: 'Sei già iscritto',
    },
    unsubscribed: {
      title: 'Disiscrizione confermata',
      lede: 'Non riceverai più newsletter da noi. Peccato — ma rispettiamo la tua scelta.',
    },
    disabled: {
      title: 'La newsletter è in pausa',
      lede: 'Al momento non accettiamo nuove iscrizioni. Torna presto — o vieni semplicemente a trovarci al ristorante.',
    },
  },

  contact: {
    title: 'Contatto & Prenotazione',
    eyebrow: 'Contatto',
    scriptLine: 'Benvenuti',
    lede: 'Vi aspettiamo. Prenotate online o chiamateci — la prenotazione è particolarmente consigliata nei weekend.',
    info: {
      title: 'Come contattarci',
      address: 'Indirizzo',
      phone: 'Telefono',
      email: 'E-mail',
      hours: 'Orari di apertura',
      social: 'Seguici',
    },
    form: {
      title: 'Scriveteci',
      lede: 'Confermiamo la vostra richiesta entro 24 ore.',
      name: 'Nome',
      email: 'E-mail',
      subject: 'Oggetto',
      subjectOptions: {
        general: 'Generale',
        reservation: 'Prenotazione',
        event: 'Richiesta evento',
        catering: 'Catering',
        feedback: 'Feedback',
        other: 'Altro',
      },
      message: 'Messaggio',
      messagePlaceholder: 'Allergie, richieste speciali, occasione …',
      consent: 'Acconsento al trattamento dei miei dati secondo l\'informativa sulla privacy.',
      submit: 'Invia messaggio',
      submitting: 'Invio in corso …',
      successTitle: 'Grazie',
      successText: 'Grazie! Il vostro messaggio è arrivato. Vi rispondiamo entro 24 ore.',
      newMessage: 'Nuovo messaggio',
      preferOnline: 'Preferite prenotare direttamente?',
      reserveLink: 'Prenotazione online →',
    },
    map: {
      address: 'Im Werth 25 · 46282 Dorsten',
      openLarger: 'Apri mappa più grande →',
    },
    faq: {
      eyebrow: 'Domande frequenti',
      title: 'Forse abbiamo la risposta',
    },
  },

  notFound: {
    scriptLine: 'Mi dispiace',
    title: '404',
    lede: 'La pagina che cerchi non esiste o è stata spostata.',
    backHome: 'Torna alla home',
  },

  aboutUs: {
    title: 'Chi siamo',
    scriptLine: 'La nostra storia',
    lede: 'La Sicilia ha due patrie — l\'isola nel Mediterraneo e il nostro ristorante a Dorsten. Una famiglia, due radici, una passione.',
    section1: {
      handwritten: 'Salvatore "Toto"',
      title: 'Da Sciacca a Dorsten',
      p1: 'Salvatore — per tutti semplicemente "Toto" — viene da Sciacca, sulla costa sud-occidentale della Sicilia, un paese di pescatori dove il mare scandisce il ritmo della giornata. Da lì ha portato con sé la cucina della sua terra: onesta, calorosa, siciliana.',
      p2: 'Quello che è iniziato come amore per la propria terra è oggi "Die Sizilianer" — un ristorante che porta la Sicilia a Dorsten. Con le ricette delle nonne, con ingredienti direttamente dall\'isola, e con la convinzione che il buon cibo vada condiviso.',
    },
    section2: {
      title: 'Una cucina tra mare e vulcano',
      p1: 'La cucina siciliana non è una semplice variante di quella italiana — è un mondo a sé. Influenzata da Greci, Arabi, Spagnoli e Normanni. Dolce e salato in un solo piatto. Pesce e terra. Pistacchio e limone.',
      p2: 'Non inventiamo nulla. Cuciniamo come si cucina a casa. Pasta alla Norma. Caponata. Cannoli con ricotta fresca. Pizza Vastasa alla catanese. E pasta al tartufo — perché anche le ricette classiche meritano un po\' di lusso.',
      motto: '„Mangiare insieme è vivere insieme."',
    },
    values: {
      first: {
        title: 'Ingredienti freschi',
        description: 'Pistacchi di Bronte, pomodori di Pachino, olio di oliva di Castelvetrano — direttamente dall\'isola.',
      },
      second: {
        title: 'Fatto in casa',
        description: 'Pasta, sughi, pane e dolci nascono ogni mattina freschi nella nostra cucina.',
      },
      third: {
        title: 'Famiglia',
        description: 'Da noi non siete in un ristorante — siete alla tavola di una famiglia siciliana.',
      },
    },
  },
  tafel: {
    pageTitle: 'Ritiro ordini',
    pageDescription: 'Quale pizza è pronta? Il tabellone del furgone pizza dei Sizilianer.',
    heading: 'Ritiro ordini',
    scriptLine: 'Pronto!',
    chooseSale: 'A quale evento vi trovate?',
    noSale: 'Al momento non c\'è nessuna vendita in corso. Il tabellone si riempie appena al furgone si scrive il primo ordine.',
    unknownSale: 'Questo tabellone non esiste — oppure la vendita è già chiusa.',
    ready: 'Pronto per il ritiro',
    inProgress: 'In preparazione',
    nothingReady: 'Ancora nulla di pronto.',
    nothingInProgress: 'Al momento non c\'è nulla nel forno.',
    asOf: 'Aggiornato alle {{zeit}}',
    waiting: 'da {{dauer}}',
    loading: 'Caricamento del tabellone…',
    loadError: 'Il tabellone non si è caricato. Riprova da solo tra pochi secondi.',
    disabled: 'Il tabellone di ritiro non è disponibile al momento.',
    privacyNote: 'Vengono mostrati solo il numero d\'ordine e — se indicato — il nome. Nessun importo, nessun contenuto dell\'ordine.',
    backToSales: 'Scegli un altro evento',
  },
  chatbot: {
    launcherLabel: 'Apri la chat',
    consent: {
      title: 'Avviare una chat con noi?',
      body: 'Sta scrivendo con un\'IA, non con una persona. Il nostro assistente chat è gestito da Baroon AI. Al caricamento il Suo indirizzo IP viene trasmesso a Baroon AI. I Suoi messaggi passano attraverso il nostro server; a tratti vi conserviamo le conversazioni per un periodo limitato (30 giorni) per verificarne la qualità — così come le pagine che visita sul nostro sito. Non La seguiamo al di fuori del nostro sito web.',
      privacy: 'Maggiori informazioni nell\'informativa sulla privacy',
      accept: 'Avvia la chat',
      decline: 'Non ora',
      error: 'Impossibile caricare la chat. La preghiamo di riprovare più tardi.',
      errorTitle: 'Chat non disponibile',
    },
    footerRevoke: 'Revocare il consenso alla chat',
  },
};
